import { render } from "./testModeToggle.vue?vue&type=template&id=6e5c19be"
import script from "./testModeToggle.vue?vue&type=script&lang=js"
export * from "./testModeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__